import { EnvironmentUrls, CurrentUser } from "Roblox";
import angular from "angular";
import chatModule from '../chatModule';

function chatService($q, chatUtility, httpService, $log, apiParamsInitialization, pinGameService, storageService, usersService) {
    "ngInject";

    var isUserAvatarInFriendsDict = function (userId, friendsDict) {
        return friendsDict[userId] && angular.isDefined(friendsDict[userId].avatarHeadshot);
    }

    var isUserPresenceInFriendsDict = function (userId, friendsDict) {
        return friendsDict[userId] && angular.isDefined(friendsDict[userId].userPresenceType);
    }

    var isUserInfoInFriendsDict = function (userId, friendsDict) {
        return isUserAvatarInFriendsDict(userId, friendsDict) && isUserPresenceInFriendsDict(userId, friendsDict);
    }

    var getConversations = function (conversationIds) {
        var params = {
            conversationIds: conversationIds
        }
        var url = EnvironmentUrls.chatApi + apiParamsInitialization.chatUrls.getConversations;
        var urlConfig = {
            url: url,
            withCredentials: true,
            retryable: true
        }
        return httpService.httpGet(urlConfig, params)
            .then(function success(conversations) {
                conversations.forEach(function (conversation) {
                    buildPinGameInConversation(conversation);
                });
                return conversations;
            });
    }

    var shouldRetrieveNextMessages = function (conversation, data) {
        // first message
        if (!conversation || !conversation.chatMessages || conversation.chatMessages.length <= 0) {
            return false;
        }

        for (var i = 0; i < data.length; i++) {
            if (data[i].id === conversation.chatMessages[0].id) {
                return false;
            }
        }

        return true;
    }

    var buildPinGameInConversation = function (conversation) {
        if (conversation.conversationUniverse) {
            var parameters = {
                rootPlaceId: conversation.conversationUniverse.rootPlaceId,
                universeId: conversation.conversationUniverse.universeId,
                actorUsername: CurrentUser.name,
                userId: parseInt(CurrentUser.userId)
            };
            pinGameService.setPinGameData(conversation, parameters);
        }
        return conversation;
    }

    var getCacheData = function (cacheData) {
        var deferred = $q.defer();
        deferred.resolve(cacheData.data);
        return deferred.promise;
    }

    var getUserConversationCallback = function (data, friendsDict) {
        var userIds = [];
        var users = [];
        var conversationIds = [];
        var conversationDict = {};
        var conversations = [];
        if (data && data.length > 0) {
            conversations = data;
            conversations.forEach(function (conversation) {
                conversation.isGroupChat = conversation.conversationType === chatUtility.conversationType.multiUserConversation;
                angular.forEach(conversation.participants, function (user) {
                    user.userId = user.targetId;
                    var userId = user.targetId;
                    if (userIds.indexOf(userId) < 0 && !isUserInfoInFriendsDict(userId, friendsDict)) {
                        userIds.push(userId);
                        users.push(user);
                    }

                    if (!friendsDict[userId]) {
                        friendsDict[userId] = {
                            id: userId,
                            name: user.name
                        }
                    }
                });
                if (!conversation.dialogType) {
                    conversation.dialogType = conversation.isGroupChat ? chatUtility.dialogType.GROUPCHAT : chatUtility.dialogType.CHAT;
                }
                buildPinGameInConversation(conversation);
                conversationIds.push(conversation.id);
                conversationDict[conversation.id] = conversation;
            });

        }

        return usersService.getUserInfo(userIds, friendsDict)
            .then(function success() {
                return conversations;
            });
    }

    return {
        apiSets: {},

        setParams: function () {
            var chatDomain = EnvironmentUrls.chatApi;
            this.apiSets["markAsReadApi"] = { url: chatDomain + "/v2/mark-as-read", retryable: false, withCredentials: true };
            this.apiSets["markAsSeenApi"] = { url: chatDomain + "/v2/mark-as-seen", retryable: false, withCredentials: true };
            this.apiSets["sendMessageApi"] = { url: chatDomain + "/v2/send-message", retryable: false, withCredentials: true };
            this.apiSets["conversationsApi"] = { url: chatDomain + "/v2/get-conversations", retryable: true, withCredentials: true };
            this.apiSets["userConversationsApi"] = { url: chatDomain + "/v2/get-user-conversations", retryable: true, withCredentials: true };
            this.apiSets["getMessagesApi"] = { url: chatDomain + "/v2/get-messages", retryable: true, withCredentials: true };
            this.apiSets["multiGetLatestMessagesApi"] = { url: chatDomain + "/v2/multi-get-latest-messages", retryable: true, withCredentials: true };
            this.apiSets["getUnreadConversationCountApi"] = { url: chatDomain + "/v2/get-unread-conversation-count", retryable: true, withCredentials: true };
            this.apiSets["startOneToOneConversationApi"] = { url: chatDomain + "/v2/start-one-to-one-conversation", retryable: true, withCredentials: true };
            this.apiSets["startGroupConversationApi"] = { url: chatDomain + "/v2/start-group-conversation", retryable: false, withCredentials: true };
            this.apiSets["addToConversationApi"] = { url: chatDomain + "/v2/add-to-conversation", retryable: true, withCredentials: true };
            this.apiSets["removeFromConversationApi"] = { url: chatDomain + "/v2/remove-from-conversation", retryable: true, withCredentials: true };
            this.apiSets["renameGroupConversationApi"] = { url: chatDomain + "/v2/rename-group-conversation", retryable: false, withCredentials: true };
            this.apiSets["updateUserTypingStatusApi"] = { url: chatDomain + "/v2/update-user-typing-status", retryable: false, withCredentials: true };
            this.apiSets["uiPerformanceTrackingApi"] = { url: EnvironmentUrls.metricsApi + "/v1/performance/send-measurement", retryable: false, withCredentials: true };
        },

        getMetaData: function () {
            var params = {}
            return httpService.httpGet(apiParamsInitialization.apiSets.getMetaData, params);
        },

        getUnreadConversationCount: function () {
            return httpService.httpGet(this.apiSets["getUnreadConversationCountApi"], null);
        },

        getUserConversations: function (pageNumberOfConversations, pageSizeOfConversations, friendsDict) {
            var paramsOfConvs = {
                pageNumber: pageNumberOfConversations,
                pageSize: pageSizeOfConversations
            };

            var localStorageName = storageService.getStorageName(storageService.chatDataName.getUserConversations, paramsOfConvs);
            var cacheData = storageService.getChatDataFromLocalStorage(localStorageName);
            if (cacheData) {
                return getCacheData(cacheData, friendsDict)
                    .then(getUserConversationCallback);

            } else {
                return httpService.httpGet(this.apiSets["userConversationsApi"], paramsOfConvs)
                    .then(function (data) {
                        storageService.saveChatDataToLocalStorage(localStorageName, data);
                        return getUserConversationCallback(data, friendsDict);
                    });
            }
        },

        getConversations: getConversations,

        addToConversation: function (participantUserIds, conversationId) {
            var data = {
                participantUserIds: participantUserIds,
                conversationId: conversationId
            }
            return httpService.httpPost(this.apiSets["addToConversationApi"], data);
        },

        removeFromConversation: function (participantUserId, conversationId) {
            var data = {
                participantUserId: participantUserId,
                conversationId: conversationId
            }
            return httpService.httpPost(this.apiSets["removeFromConversationApi"], data);
        },

        startOneToOneConversation: function (participantUserId) {
            var data = {
                participantUserId: participantUserId
            }
            return httpService.httpPost(this.apiSets["startOneToOneConversationApi"], data)
                .then(function (data) {
                    if (data) {
                        var conversation = data.conversation;
                        buildPinGameInConversation(conversation);
                        return conversation;
                    }
                });
        },

        startGroupConversation: function (participantUserIds, title) {
            var data = {
                participantUserIds: participantUserIds,
                title: title

            }
            return httpService.httpPost(this.apiSets["startGroupConversationApi"], data);
        },

        getMessages: function (conversationId, exclusiveStartMessageId, pageSize) {
            var params = {
                conversationId: conversationId,
                exclusiveStartMessageId: exclusiveStartMessageId,
                pageSize: pageSize
            }

            return httpService.httpGet(this.apiSets["getMessagesApi"], params);
        },

        getMessagesByPageSize: function (conversation, exclusiveStartMessageId, pageSize, allData, update, messageReceiveStartTime) {
            var chatService = this;
            this.getMessages(conversation.id, exclusiveStartMessageId, pageSize)
                .then(
                    function (data) {
                        if (data && data.length > 0) {
                            var nextPageSize = pageSize * 2;
                            data.forEach(function (message) {
                                allData.push(message);
                            });

                            //repeat if all messages have not been retrieved nor reached max page size
                            if (shouldRetrieveNextMessages(conversation, data) && nextPageSize <= chatUtility.dialogParams.pageSizeOfGetMessages && data.length === pageSize) {
                                chatService.getMessagesByPageSize(conversation, data[data.length - 1].id, nextPageSize, allData, update, messageReceiveStartTime);
                            } else {
                                update(messageReceiveStartTime);
                            }
                        } else if (data && data.length === 0) {
                            update(messageReceiveStartTime);
                        }
                    }
                );
        },

        multiGetLatestMessages: function (conversationIds, pageSize) {
            var params = {
                conversationIds: conversationIds,
                pageSize: pageSize
            }
            return httpService.httpGet(this.apiSets["multiGetLatestMessagesApi"], params);
        },

        markAsRead: function (conversationId, endMessageId) {
            var data = {
                conversationId: conversationId,
                endMessageId: endMessageId
            }
            return httpService.httpPost(this.apiSets["markAsReadApi"], data);
        },

        markAsSeen: function (conversationIdsToMarkRead) {
            var data = {
                conversationsToMarkSeen: conversationIdsToMarkRead
            }
            return httpService.httpPost(this.apiSets["markAsSeenApi"], data);
        },

        sendMessage: function (conversationId, message) {
            var data = {
                conversationId: conversationId,
                message: message
            }
            return httpService.httpPost(this.apiSets["sendMessageApi"], data);
        },

        renameGroupConversation: function (conversationId, newTitle) {
            var data = {
                conversationId: conversationId,
                newTitle: newTitle
            }
            return httpService.httpPost(this.apiSets["renameGroupConversationApi"], data);
        },

        updateUserTypingStatus: function (conversationId, isTyping) {
            var data = {
                conversationId: conversationId,
                isTyping: isTyping
            }
            return httpService.httpPost(this.apiSets["updateUserTypingStatusApi"], data);
        },

        sendPerformanceData: function (measureName, value) {
            var data = {
                featureName: "Chat",
                measureName: measureName,
                value: value
            }
            return httpService.httpPost(this.apiSets["uiPerformanceTrackingApi"], data);
        }
    }
};

chatModule.factory("chatService", chatService);

export default chatService;